import React from "react";
import MuiLink from "@mui/material/Link";
import PropTypes from "prop-types";

/**
 * Link component wrapper for navigation links.
 * Wraps Material-UI Link for consistent imports.
 * 
 * @component
 * @example
 * <Link href="/page">Link Text</Link>
 * 
 * @example
 * <Link component="button" onClick={handleClick}>Button Link</Link>
 */
const Link = ({ children, ...props }) => {
  return <MuiLink {...props}>{children}</MuiLink>;
};

Link.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * The color of the link
   */
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
    "inherit",
  ]),
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * Controls when the link should have an underline
   */
  underline: PropTypes.oneOf(["none", "hover", "always"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
  /**
   * The URL to link to
   */
  href: PropTypes.string,
  /**
   * Callback fired when the link is clicked
   */
  onClick: PropTypes.func,
};

export default Link;
